import React, { useEffect, useRef, useState } from "react";
import { useRequestProcessor } from "../../requestProcessor";

import moment from "moment";
import { eventAction } from "../../QueryFunctions/queryfunction";

const imageUrls = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYRy5KxOqyoXyL91IL1E1k_tQCf78ZQFudtA&s",
  "https://dayswithgrey.com/wp-content/uploads/2022/10/outdoor-activities-for-kids-109.jpg",
  "https://elfapreschools.com/singapore/wp-content/uploads/2022/04/Outdoor-relay-allows-children-to-soak-up-the-sun-and-expand-locomotor-skills-600x450.jpeg",
  "https://dayswithgrey.com/wp-content/uploads/2022/10/outdoor-activities-for-kids-113.jpg",
];

const Item = ({ item, index, refetch }) => {
  const { useMutationWrapper } = useRequestProcessor();
  const [selectedItem, setSelectedItem] = useState(null);
  const modalRef = useRef();
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const toggleDetailModal = () => setIsDetailModalOpen(!isDetailModalOpen);
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const randomImage = imageUrls[Math.floor(Math.random() * imageUrls.length)];
    setImageUrl(randomImage);
  }, []);

  const handleItemClick = () => {
    console.log("clicked");
    setSelectedItem(item);
    toggleDetailModal();
  };
  const eventActionFn = useMutationWrapper(
    "eventAction",
    ({ event_id, status }) => {
      // console.log("Event Action: " , event_id,status);
      toggleDetailModal();
      return eventAction(event_id, status);
    },
    {
      onSuccess: (data) => {
        refetch();
      },
    }
  );
  // const eventActionReq = useMutationWrapper(
  //   'eventActionReq',
  //   async (eventId, type) => {
  //     const consent_by = parent?.parentType;
  //     const url = `/centerevents/event_act`;
  //     const body = {
  //       event_id: eventId,
  //       consent_by: consent_by,
  //       status: type,
  //     };
  //     const center = 100;
  //     // const child_id = id;
  //     const child_id = 40417;
  //     const center_id = 100;
  //     const room_id = 3;
  //     const res = await axiosClient.post(
  //       url,
  //       { ...body, center, center_id, child_id, room_id },
  //       {
  //         headers: {
  //           Auth_token: token,
  //           Child_id: 40417,
  //         },
  //       }
  //     );

  //     return res.data;
  //   },
  //   {
  //     onSuccess: data => {},
  //     onError: error => {
  //       //Set Error
  //     },
  //   }
  // );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsDetailModalOpen(false);
      }
    };

    if (isDetailModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDetailModalOpen]);
  return (
    <>
      <div
        className=" cursor-pointer col-span-12 bg-white lg:col-span-6 grid grid-cols-12 gap-x-2 gap-y-1  shadow-md  rounded-lg mx-2"
        onClick={handleItemClick}
      >
        <div className="col-span-4">
          <img
            className="rounded-l-lg h-full w-full object-cover"
            alt="Activity"
            src={imageUrl}
          ></img>
        </div>
        <div className="col-span-8 pt-1 pb-2 pr-2 space-y-1">
          <h2 className=" text-base font-semibold line-clamp-1 ">
            {" "}
            {item?.event_title}
          </h2>
          <div className="flex">
            {/* <span className="text-sm font-semibold"> Event Date :</span> &nbsp; */}
            <h3 className="text-header text-sm">
              <i class="bi bi-clock text-header"></i>{" "}
              {moment(item?.event_date).format("ll")}
            </h3>
          </div>
          {/* <div className="flex">
            <span className="text-sm font-semibold">Created On :</span> &nbsp;
            <h3 className="text-header text-sm">
              <i class="bi bi-clock text-header"></i>{" "}
              {moment(item?.event_created_on).format("lll")}
            </h3>
          </div> */}

          <div className="font-semibold text-sm xl:text-lg">
            <div className="flex items-center gap-2">
              <span>Status:</span>
              <span
                className={`px-3 py-1 rounded-full text-white text-xs xl:text-sm font-medium ${
                  item?.consent_status === "Authorized"
                    ? "bg-green-500"
                    : item?.consent_status === "Denied"
                    ? "bg-red-500"
                    : "bg-yellow-500"
                }`}
              >
                {item?.consent_status || "Authorization Pending"}
              </span>
            </div>
          </div>
          <p className="keep-all text-sm line-clamp-2 xl:text-sm xl:mr-10">
            {item?.event_details}
          </p>
        </div>
      </div>
      {isDetailModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleDetailModal}
        />
      )}
      {isDetailModalOpen && selectedItem && (
        <div
          ref={modalRef}
          id="hs-vertically-centered-modal"
          className="hs-overlay fixed inset-0 z-[80] flex items-center justify-center overflow-x-hidden overflow-y-auto pointer-events-auto w-full"
          role="dialog"
          tabIndex="-1"
          aria-labelledby="hs-vertically-centered-modal-label"
        >
          <div className="mt-7 opacity-100 duration-500 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center justify-center">
            <div className="w-full flex flex-col bg-white  shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
              <div className=" flex justify-between items-center py-3 px-4  dark:border-neutral-700 bg-header rounded-t-xl">
                <h3
                  id="hs-vertically-centered-modal-label"
                  className="font-bold text-white dark:text-white "
                >
                  {selectedItem.event_title}
                </h3>
                <button
                  type="button"
                  className="inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
                  aria-label="Close"
                  onClick={toggleDetailModal}
                >
                  <span className="sr-only">Close</span>
                  <svg
                    className="shrink-0 size-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                  </svg>
                </button>
              </div>
              <div className="p-4 overflow-y-auto">
                <p className="text-gray-800 dark:text-neutral-400">
                  <span className="font-bold">Event Date:</span>{" "}
                  {moment(selectedItem.event_date).format("ll")}
                </p>
                <p className="text-gray-800 dark:text-neutral-400">
                  <span className="font-bold">Request Created On:</span>{" "}
                  {moment(selectedItem.event_created_on).format("ll")}
                </p>
                <p className="text-gray-800 dark:text-neutral-400">
                  <span className="font-bold">Details:</span>{" "}
                  {selectedItem.event_details}
                </p>
                {/* Add more details as needed */}
              </div>
              <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-neutral-700">
                <div>
                  {(moment().isBefore(item.event_date) ||
                    moment().format("YYYY-MM-DD") === item.event_date) &&
                  item.event_status !== "Cancelled" ? (
                    <div>
                      {item.consent_status !== "Authorized" ? (
                        <button
                          className="btn btn-success"
                          type="button"
                          onClick={() => {
                            eventActionFn.mutate({
                              event_id: item?.event_id,
                              status: "Authorized",
                            });
                          }}
                        >
                          Authorise
                        </button>
                      ) : null}
                      {item.consent_status !== "Denied" ? (
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => {
                            eventActionFn.mutate({
                              event_id: item?.event_id,
                              status: "Denied",
                            });
                          }}
                        >
                          Deny
                        </button>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                {/* <button
                  type="button"
                  className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700"
                  onClick={toggleDetailModal}
                >
                  Close
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Item;
